import uteFlowLogo from "@/assets/uteflow-logo.png";

export default function BrandLogo({
  className = "",
  iconClassName = "w-10 h-10 rounded-xl",
  textClassName = "text-xl font-extrabold tracking-tight font-heading text-foreground",
  name = "UteFlow",
}) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`.trim()}>
      <img src={uteFlowLogo} alt={`${name} logo`} className={`${iconClassName} object-cover`} />
      <span className={textClassName}>{name}</span>
    </div>
  );
}
